// PriceTag.jsx
import React from "react";
import './PriceTag.css';

const toINR = (n) =>
    typeof n === "number" && !Number.isNaN(n) ? `₹${n.toFixed(2)}` : "₹0.00";

const PriceRow = ({ mrp, sell }) => {
    const hasDiscount =
        typeof mrp === "number" &&
        typeof sell === "number" &&
        mrp > 0 &&
        sell > 0 &&
        sell < mrp;

    return (
        <div className="price-row">
            {hasDiscount ? (
                <div className="price-pair">
                    <span className="mrp">
                        {toINR(mrp)}
                    </span>
                    <span className="sell">
                        {toINR(sell)}
                    </span>
                </div>
            ) : (
                <p className="single">MRP: {toINR(sell || mrp)}</p>
            )}
        </div>
    );
};

export default function PriceTag({ product }) {
    // Accept either ...bigPrice / ...smallPrice or ...bigUnitPrice / ...smallUnitPrice
    const big =
        product?.bigPrice || product?.bigUnitPrice || product?.big_unit_price;
    const small =
        product?.smallPrice || product?.smallUnitPrice || product?.small_unit_price;

    const showSmall =
        product?.unitRestrictions === false &&
        small &&
        ((small.productSellingPrice ?? 0) > 0 || (small.productmrPrice ?? 0) > 0);

    return (
        <div className="price-tag">
            {/* Line 1: Big price */}
            <PriceRow
                mrp={big?.productmrPrice}
                sell={big?.productSellingPrice}
            />

            {/* Line 2: Small price (only when unitRestrictions is false) */}
            {showSmall && (
                <PriceRow
                    mrp={small?.productmrPrice}
                    sell={small?.productSellingPrice}
                />
            )}
        </div>
    );
}
